import angular from 'angular'
import openedInvoice from './openedInvoice'
import cancelInvoice from './cancelInvoice'

export default angular
    .module('outputManage.billManage', [openedInvoice, cancelInvoice])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('outputManage.billManage', {
            url: '/ovat',
            template: '<div ui-view></div>',
            abstract: true,
            title: '发票管理',
        })
        // .state()
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/index.js